import React, { useState, useEffect } from 'react';
import { Grid, Avatar, Chip, Card, CardContent, CircularProgress, Pagination } from '@mui/material';
import { Link, useNavigate, useParams } from "react-router-dom";
// import moment from 'moment-timezone';

const MyChecklistCard = (props) => {
    const { item, getChecklistDetails, setTitle, setShowModal, listType } = props
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (_, value) => {
        setCurrentPage(value);
    };

    return (
        <>
            <Grid item className='align-items-center p-2' fontFamily={'karla'} md={6}>
                <Card sx={{ backgroundColor: 'rgba(245, 245, 245, 0.4)', marginBottom: '25px', border: '1px solid #cccccc', borderRadius: '12px' }} elevation={0}>

                    <CardContent>
                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #cccccc' }}>
                            <p style={{ fontSize: '16px', fontWeight: '550', fontFamily: 'karla' }}>{item?.checklist?.title}</p>
                            <div className="d-flex" style={{ gap: 10 }}>

                                <Chip
                                    variant="outlined"
                                    sx={{
                                        backgroundColor: '#EAECF0',
                                        color: '#2B3F6C',
                                        border: '1px solid #2B3F6C',
                                        cursor: 'pointer'
                                    }}
                                    avatar={<Avatar src="/images/eye.png" style={{ width: 28, height: 24, padding: 2 }} />}
                                    label={'Checklists'}
                                    onClick={() => {
                                        setShowModal(true)
                                        setTitle(item?.checklist?.title)
                                        getChecklistDetails(item?.checklist_id)
                                    }}
                                />

                                {item.status == "pending" ?
                                    <Link style={{ pointerEvents: item.is_filled === 0 ? 'none' : 'auto' }} to={`/firehouse/mychecklist-item/${item?.checklist_id}/${item?.id}`}>
                                        <Chip
                                            variant="outlined"
                                            sx={{
                                                backgroundColor: item.is_filled === 0 ? '#D0D5DD' : '#BF1D2D',
                                                color: '#F5F5F5',
                                                border: item.is_filled === 0 ? ' none' : '1px solid #BF1D2D',
                                                cursor: 'pointer'
                                            }}
                                            avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                            label={'Fill'}
                                            disabled={item.is_filled === 0}
                                        />
                                    </Link>
                                    :
                                    item.status == "completed" ?
                                        <Link to={`/firehouse/mychecklist-item/${item?.checklist_id}/${item?.id}`}>
                                            <Chip
                                                variant="outlined"
                                                sx={{
                                                    backgroundColor: '#01784F',
                                                    color: '#F5F5F5',
                                                    border: '1px solid #01784F',
                                                    cursor: 'pointer'
                                                }}
                                                avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                                label={'Filled'}
                                            />
                                        </Link>
                                        :
                                        item.status == "started" ?
                                            <Link to={`/firehouse/mychecklist-item/${item?.checklist_id}/${item?.id}`}>
                                                <Chip
                                                    variant="outlined"
                                                    sx={{
                                                        backgroundColor: '#BF1D2D',
                                                        color: '#F5F5F5',
                                                        border: '1px solid #BF1D2D',
                                                        cursor: 'pointer'
                                                    }}
                                                    avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                                    label={'Resume Filling'}
                                                />
                                            </Link>
                                            :
                                            item.status == "failed" ?
                                                <Link to={`/firehouse/mychecklist-item/${item?.checklist_id}/${item?.id}`}>
                                                    <Chip
                                                        variant="outlined"
                                                        sx={{
                                                            backgroundColor: '#2E3238',
                                                            color: '#F5F5F5',
                                                            border: '1px solid #2E3238',
                                                            cursor: 'pointer'
                                                        }}
                                                        avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                                        label={'Failed'}
                                                    />
                                                </Link>
                                                :
                                                <Chip
                                                    variant="outlined"
                                                    sx={{
                                                        backgroundColor: '#BF1D2D',
                                                        color: '#F5F5F5',
                                                        border: '1px solid #BF1D2D',
                                                        cursor: 'pointer'
                                                    }}
                                                    avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                                    label={'Error'}
                                                />
                                }
                            </div>
                        </div>

                        <div className='mt-3'>
                            <span className="highlight-btn">Assigned by</span>: {item?.checklist?.employee_full_name}
                        </div>

                        <div className={`mt-3 d-flex ${(item.status == "pending" && listType == "Past") && 'red-font'}`}>
                            {item?.due_statement}
                        </div>

                    </CardContent>
                </Card>
            </Grid>
        </>
    )
}

export default MyChecklistCard

{/* {(item.status == "pending" &&
                            listType == "Past" &&
                            moment.tz(item.checklist_date, 'America/New_York').isSame(moment.tz('America/New_York'), 'day'))
                            || (item.status == "pending" &&
                                listType == "Past" &&
                                !moment.tz(item.checklist_date, 'America/New_York').isBefore(moment.tz('America/New_York').subtract(1, 'days'), 'day')) ?
                            <div className='mt-3 d-flex red-font'>
                                {item?.due_statement}
                            </div>
                            :
                            <div className='mt-3 d-flex'>
                                {item?.due_statement}
                            </div>
                        } */}

{/* {(item.status == "pending" && listType == "Past") ?
                            <div className='mt-3 d-flex red-font'>
                                {item?.due_statement}
                            </div>
                            :
                            <div className='mt-3 d-flex'>
                                {item?.due_statement}
                            </div>
                        } */}